import React, { useEffect, useRef, useState } from "react";

/**
 * Global hover tooltip.
 *
 * İşlemler kolonundaki ikon butonlarının çoğunda zaten `title` var, ama tarayıcının
 * yerleşik ipucu ~1-2 sn gecikmeyle ve soluk çıkıyor; admin "hangi buton olduğunu
 * göremiyorum" diyordu. Bu bileşen layout'a bir kez asılır, `title` taşıyan her
 * öğede anında okunur bir ipucu gösterir. Sayfa sayfa buton düzenlemeye gerek yok.
 *
 * Çalışma şekli: hover'da `title` geçici olarak `data-hover-title`e taşınır (yerleşik
 * ipucu bastırılır), ayrılınca geri yazılır — DOM kalıcı olarak değişmez.
 */
const HoverTooltip = () => {
  const [tip, setTip] = useState(null); // { text, x, y }
  const activeRef = useRef(null);

  useEffect(() => {
    const restore = () => {
      const el = activeRef.current;
      if (el && el.dataset.hoverTitle != null) {
        el.setAttribute("title", el.dataset.hoverTitle);
        delete el.dataset.hoverTitle;
      }
      activeRef.current = null;
    };

    const onOver = (e) => {
      const el = e.target.closest("[title]");
      if (!el || el === activeRef.current) return;
      const text = (el.getAttribute("title") || "").trim();
      if (!text) return;

      restore();
      activeRef.current = el;
      el.dataset.hoverTitle = text;
      el.removeAttribute("title");

      const r = el.getBoundingClientRect();
      setTip({ text, x: r.left + r.width / 2, y: r.top });
    };

    const onOut = (e) => {
      if (!activeRef.current) return;
      if (e.relatedTarget && activeRef.current.contains(e.relatedTarget)) return;
      restore();
      setTip(null);
    };

    // Tooltip açıkken sayfa kayarsa konum bozulmasın.
    const onScroll = () => {
      if (!activeRef.current) return;
      restore();
      setTip(null);
    };

    document.addEventListener("mouseover", onOver, true);
    document.addEventListener("mouseout", onOut, true);
    window.addEventListener("scroll", onScroll, true);
    return () => {
      document.removeEventListener("mouseover", onOver, true);
      document.removeEventListener("mouseout", onOut, true);
      window.removeEventListener("scroll", onScroll, true);
      restore();
    };
  }, []);

  if (!tip) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: tip.x,
        top: tip.y - 8,
        transform: "translate(-50%, -100%)",
        background: "#2a3042",
        color: "#fff",
        padding: "4px 9px",
        borderRadius: 4,
        fontSize: 12,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
        maxWidth: 320,
        boxShadow: "0 2px 8px rgba(0,0,0,.25)",
        pointerEvents: "none",
        zIndex: 3000,
      }}
    >
      {tip.text}
    </div>
  );
};

export default HoverTooltip;
